export const PAGE_SIZE = {
	DEFAULT: 15,
	OPERACIONES: 15,
	HISTORIAL: 5,
	USER: 10,
	MENSAJES: 10,
};

